import { render } from "./Laskuri.vue?vue&type=template&id=04a0fe70&scoped=true"
import script from "./Laskuri.vue?vue&type=script&lang=js"
export * from "./Laskuri.vue?vue&type=script&lang=js"

import "./Laskuri.vue?vue&type=style&index=0&id=04a0fe70&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a0fe70"]])

export default __exports__